export default __webpack_public_path__ + "static/link-01b-dont-2d82e5177a95dbab32b4fb8da745b6430868ceae4fbd8e44717ebf4b0d61bea4.png";